<div class="loading-overlay" *ngIf="isLoading$ | async">
    <div class="loading-spinner"></div>
    <p class="loading-text">Cargando ...</p>
</div>

<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>